export const type = 'changeNavSelected'

const changeNavSelected = index => {
    return {
        type,
        payload: index
    }
}

export default changeNavSelected